const statusCampaign = {
  PENDING_TO_START_DATE: 1,
  ACTIVE: 2,
  FINISHED: 3,
  CANCELED: 4,
};

export default {
  statusCampaign,
};
